module.exports = __webpack_public_path__ + "img/logonew.a0d2c170.svg";